import { contactErrors, contactTelHref, type ContactField, type ContactForm } from '../lib/contacts';
import { Field, TextInput } from './ui/Field';

export function ContactFields({ kind, value, onChange, emailEnabled, disabled = false }: {
  kind: 'collection' | 'delivery'; value: ContactForm; onChange: (field: ContactField, value: string) => void;
  emailEnabled: boolean; disabled?: boolean;
}) {
  const errors = contactErrors(value, emailEnabled);
  return <fieldset aria-label={`${kind === 'collection' ? 'Collection' : 'Delivery'} contact`} className="mt-3 space-y-3">
    {(['Name', 'Phone', ...(emailEnabled ? ['Email'] : [])] as const).map(suffix => {
      const field = `${kind}Contact${suffix}` as ContactField;
      return <Field key={field} label={suffix === 'Name' ? 'Contact name' : suffix} optional
        hint={errors[field] ? <span className="text-st-cancelled">{errors[field]}</span> : undefined}>
        <TextInput value={value[field]} onChange={event => onChange(field, event.target.value)}
          type={suffix === 'Phone' ? 'tel' : suffix === 'Email' ? 'email' : 'text'}
          maxLength={suffix === 'Name' ? 120 : suffix === 'Phone' ? 30 : 254} disabled={disabled}
          aria-invalid={!!errors[field]} />
      </Field>;
    })}
  </fieldset>;
}

export function ContactDetails({ kind, job, emailEnabled }: {
  kind: 'collection' | 'delivery'; job: Partial<Record<ContactField, string | null>>; emailEnabled: boolean;
}) {
  const name = job[`${kind}ContactName`]?.trim();
  const phone = job[`${kind}ContactPhone`]?.trim();
  const email = emailEnabled ? job[`${kind}ContactEmail`]?.trim() : null;
  if (!name && !phone && !email) return null;
  const href = phone ? contactTelHref(phone) : null;
  return <div className="space-y-2 pb-3 text-[14px]">
    {href ? <a href={href} className="inline-flex max-w-full break-words rounded-[10px] bg-[var(--tag-contact-fill)] px-3 py-2 font-semibold text-white">
      {name ? `Call ${name} · ${phone}` : phone}
    </a> : (name || phone) ? <p className="break-words text-ink2">{[name, phone].filter(Boolean).join(' · ')}</p> : null}
    {email && <p><a href={`mailto:${email}`} className="break-words text-[color:var(--ck-link)] hover:underline">{email}</a></p>}
  </div>;
}
